module.exports = __webpack_public_path__ + "static/media/app.8b254288.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/app.svg
// module id = 415
// module chunks = 37